import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

import { Settings } from '../../types/fam-graphql'
import type { RootState } from '../store'

import { actionTypes } from './types'

export type SettingsState = {
  list: Settings | null
  generatingMessage: string[] | null
}

//
// Initial state
//

const initialState: SettingsState = {
  list: null,
  generatingMessage: null,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    init: () => undefined,
    setSettings: (state, action: actionTypes.setSettings) => {
      state.list = action.payload
    },
    setGeneratingMessage: (state, action: actionTypes.setGeneratingMessage) => {
      state.generatingMessage = action.payload
    },
  },
  extraReducers: {
    [HYDRATE]: (_state, action) => {
      return action.payload.settings
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state.settings
const list = (state: RootState) => root(state).list
const generatingMessage = (state: RootState) => root(state).generatingMessage

export const selectors = {
  list,
  generatingMessage,
}
